import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../stylesheets/courses.css';
import axios from 'axios';

const Courses = () => {
    const [activeMenu, setActiveMenu] = useState(null);
    const navigate = useNavigate();
    const [items, setItems] = useState([]);

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BASE_URL}/course/get-all-course-ids`
                );
                setItems(response.data?.courses || []);
            } catch (error) {
                console.error("Failed to fetch courses", error);
            }
        };
        fetchCourses();
    }, []);

    const handleMenuClick = (id) => {
        // Toggle the dropdown for the selected course
        setActiveMenu(activeMenu === id ? null : id);
    };

    const handleMenuAction = (action, item) => {
        setActiveMenu(null);

        // Handle navigation based on the action clicked
        switch (action) {
            case 'Attendance':
                navigate(`/faculty/attendance/${item}`);
                break;
            case 'Assignment Marks':
                navigate(`/faculty/scores/${item}/assignments`);
                break;
            case 'Exam Marks':
                navigate(`/faculty/scores/${item}/exams`);
                break;
            case 'Quiz Marks':
                navigate(`/faculty/scores/${item}/quizzes`);
                break;
            default:
                break;
        }
    };

    return (
        <div className="list-container">
            <ul className="list">
                {items.map((item) => (
                    <li key={item} id="list-item">
                        <div><span className="item-title">{item}</span></div>

                        {/* Three-dot menu button */}
                        <span
                            className="menu-icon"
                            onClick={() => handleMenuClick(item)} // Use `item` for toggle logic
                        >
                            ⋮
                        </span>

                        {/* Dropdown menu */}
                        {activeMenu === item && ( // Compare directly with `item`
                            <div className="dropdown-menu">
                                <ul>
                                    <li onClick={() => handleMenuAction('Attendance', item)}>Attendance</li>
                                    <li onClick={() => handleMenuAction('Quiz Marks', item)}>Quiz Marks</li>
                                    <li onClick={() => handleMenuAction('Assignment Marks', item)}>Assignment Marks</li>
                                    <li onClick={() => handleMenuAction('Exam Marks', item)}>Exam Marks</li>
                                </ul>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Courses;
